import { render } from "./LottiePlayer.vue?vue&type=template&id=57869698"
import script from "./LottiePlayer.vue?vue&type=script&lang=js"
export * from "./LottiePlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__